import type { ButtonProps } from '@wwe-portal/ui/components/button';
import { Button } from '@wwe-portal/ui/components/button';
import { FacebookIcon } from '@wwe-portal/ui/components/icons/facebook-icon';
import { ScopelyIcon } from '@wwe-portal/ui/components/icons/scopely-icon';
import { cn } from '@wwe-portal/ui/lib/lib';

export function FacebookButton({ className, children, ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      className={cn(
        'h-[40px] bg-[#245fdc] px-0 font-semibold text-white',
        className
      )}
      variant="none"
    >
      <div className="flex flex-row gap-2.5">
        <FacebookIcon className="h-5 w-3" fill="white" />
        <span>{children ?? 'Login with Facebook'}</span>
      </div>
    </Button>
  );
}

export function ScopelyButton({ className, children, ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      className={cn(
        'bg-text700 h-[40px] px-0 font-semibold text-white',
        className
      )}
      variant="none"
    >
      <div className="flex flex-row">
        <ScopelyIcon />
        <span>{children ?? 'Login with Scopely'}</span>
      </div>
    </Button>
  );
}
